module.exports = __webpack_public_path__ + "static/media/Calendar.69be7824.svg";